import React from 'react';
import PropTypes from 'prop-types';

import ClockIcon from '@components/icons/clock/clock';
import Copy from '@components/atoms/copy/copy';
import StyledEducationTime from './educationTime.style';

const EducationTime = ({ large = false, value = 0, ...props }) => {
  return (
    <StyledEducationTime {...props} large={large}>
      <ClockIcon className="time__icon" />
      <Copy className="time__tag">{value} Min</Copy>
    </StyledEducationTime>
  );
};

EducationTime.propTypes = {
  value: PropTypes.number,
  large: PropTypes.bool
};

export default EducationTime;
